export default __webpack_public_path__ + "static/media/free_board_banner_v3.59fe0f10.png";